import UserBadge from "@/components/shared/UserBadge";
import React from "react";
import { ArrowIcon, useAmiraMessage } from "@/components/Global";
import ResourceGuide from "@/components/Teacher/ResourceGuide";
import "./StudentNotReadingOrEngaging.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import rosterCreators from "@/components/Reports/state/roster/creators";
import { RootState } from "@/models";
import { useTranslation } from "react-i18next";

export const StudentNotReadingOrEngaging: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { onToggleModal } = useAmiraMessage();
  const { t } = useTranslation("alerts");
  // Get students from Redux store
  const roster = useSelector((state: RootState) => state.reports?.roster);
  const classroom = roster?.ui?.selections?.classroom;
  const studentsRoster = roster?.data?.student || [];

  // Filter students by current classroom and take first 3
  const students = studentsRoster
    .filter((s: any) => s.classroom_id.includes(`${classroom?.id}`))
    .slice(0, 3)
    .map((s: any) => ({
      id: s.id,
      firstName: s.first_name,
      lastName: s.last_name,
      grade: s.grade,
    }));

  const onProgressReportClick = (studentId: string) => {
    const student = students.find((s: any) => s.id === studentId);

    if (!student) return;

    dispatch(
      rosterCreators.rosterSelect({
        type: "student",
        data: {
          id: student.id,
          label: `${student.firstName} ${student.lastName}`,
          first_name: student.firstName,
          last_name: student.lastName,
          grade: student.grade,
        },
      }) as any
    );

    dispatch({
      type: "SET_TEACHER_SELECT_STATE",
      payload: {
        selections: {
          metric: {
            label: "Overall Reading: ARM Score",
            value: "ARM",
          },
          scale: { value: "ARM", label: "ARM Scale" },
          benchmark: {
            value: `NationalNorms_0`,
            label: `National Norms - ${student.grade}`,
            grade: student.grade,
          },
        },
      },
    });

    navigate("/teacher/reports/type/progress");
    onToggleModal(false);
  };

  return (
    <div className="student-not-reading-modal">
      <p className="student-not-reading-modal__description">
        {t("StudentNotReadingOrEngaging.modal_description")}
      </p>

      <div className="student-not-reading-modal__students-container">
        {students.map((student: any) => (
          <div
            key={student.id}
            className="student-not-reading-modal__student-row"
          >
            <div className="student-not-reading-modal__student-badge">
              <UserBadge name={`${student.firstName} ${student.lastName}`} />
              {student.firstName} {student.lastName}
            </div>

            <span
              className="student-not-reading-modal__progress-link"
              onClick={() => onProgressReportClick(student.id)}
            >
              {t("StudentNotReadingOrEngaging.review_progress_report")}
              <div className="student-not-reading-modal__arrow-icon">
                <ArrowIcon />
              </div>
            </span>
          </div>
        ))}

        <div className="student-not-reading-modal__divider" />
        <div className="student-not-reading-modal__divider" />
        <div className="student-not-reading-modal__divider" />
      </div>

      <ResourceGuide />
      <div className="student-not-reading-modal__actions">
        <button className="student-not-reading-modal__action-button">
          {t("StudentNotReadingOrEngaging.dismiss")}
        </button>
        <button className="student-not-reading-modal__action-button">
          {t("StudentNotReadingOrEngaging.snooze")}
        </button>
      </div>
    </div>
  );
};

export default StudentNotReadingOrEngaging;
